// noinspection ES6CheckImport

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import MaterialTableHead from '@material-ui/core/TableHead';
import ReportConversionContext from '@/modules/reports/contexts/ReportConversionContext';
import TableCellOrder from '@/modules/common/components/TableCellOrder';
import { formatDate } from '~/common';

const TableHead = (props) => {
    // noinspection JSCheckFunctionSignatures
    const reportConversionContext = useContext(ReportConversionContext);

    return (
        <MaterialTableHead>
            <TableRow>
                {props.days.map((date, id) => (
                    <TableCellOrder key={id} className="conversion" orderName={formatDate(date, 'yyyy-MM-dd')}
                                    ordering={reportConversionContext.ordering}
                                    onClick={reportConversionContext.handleClickOrder}
                    >
                        {formatDate(date, 'dd.MM')}
                    </TableCellOrder>
                ))}
            </TableRow>
        </MaterialTableHead>
    );
};

TableHead.propTypes = {
    days: PropTypes.array.isRequired,
    report: PropTypes.object.isRequired,
};

export default TableHead;
